import styles from './TaskSurveyPopup.module.scss'

export const TRANSITION_CLASSES = {
  appear: styles.transitionEnter,
  appearActive: styles.transitionEnterActive,
  enter: styles.transitionEnter,
  enterActive: styles.transitionEnterActive,
  exit: styles.transitionExit,
  exitActive: styles.transitionExitActive,
}
